import React, { useEffect, useState } from 'react';
import ValueMapSelectorPage from 'src/pages/InsigthPage/ValueMap/ValueMapSelectorPage';
import polygonsService from 'src/services/polygonsService';
import segmentacionService from 'src/services/segmentacionService';

const ValueMapsListContainer = () => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [segments, setSegments] = useState([]);
  const [SubSgments, setSubSegments] = useState([]);
  const [territories, setTerritories] = useState([]);
  const [route, setRoute] = useState({});

  const reloadCategorys = async () => {
    const response = await segmentacionService.getCategorias();
    setCategories(response);
  };

  const selectedButton = (array, item) => {
    array.forEach((element, index) => {
      if (element.id === item.id) {
        Object.assign(array[index], { selected: true });
      } else {
        Object.assign(array[index], { selected: false });
      }
    });
  };

  const reloadTerritories = async (id) => {
    const response = await polygonsService.getTerritorios(id);
    setTerritories(response);
  };

  const reloadSubCategories = async (categorie) => {
    const response = await segmentacionService.getSubCategorias(categorie.id);
    setRoute({
      cat: categorie.categoria,
    });
    reloadTerritories(categorie.id === '1' ? '8' : categorie.id);
    selectedButton(categories, categorie);
    setSubCategories(response);
    setSegments([]);
    setSubSegments([]);
  };

  const handleSelectTerritorie = (value) => {
    setRoute((prev) => ({
      ...prev,
      id: value?.id || '',
      territorio: value?.territorio || '',
      unidad_negocio_id: value?.unidad_negocio_id || '',
    }));
  };

  const reloadSegments = async (segment) => {
    const response = await segmentacionService.getSegmentos(segment.id);
    setRoute((prev) => ({
      ...prev,
      subCat: segment.subcategoria,
    }));
    selectedButton(subCategories, segment);
    setSegments(response);
    setSubSegments([]);
  };

  const reloadSubSegments = async (SubSegments) => {
    const response = await segmentacionService.getSubSegmentos(SubSegments.id);
    setRoute((prev) => ({
      ...prev,
      seg: SubSegments.segmento,
    }));
    selectedButton(segments, SubSegments);
    setSubSegments(response);
  };

  useEffect(() => {
    reloadCategorys();
  }, []);

  return (
    <ValueMapSelectorPage
      segments={segments}
      route={route}
      territories={territories}
      categories={categories}
      subCategories={subCategories}
      SubSgments={SubSgments}
      handleSelectCat={reloadSubCategories}
      handleSelectSubCat={reloadSegments}
      handleSelectSeg={reloadSubSegments}
      handleSelectTerritorie={handleSelectTerritorie}
    />
  );
};

export default ValueMapsListContainer;
